<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="closeCreateMessageModal", :is-blur="true")
        .create-modal__header
            div(slot='header')
                | {{ $i18n.t('battle.battle_user_record_holder_title_modal') }}
            p
            .create-body
                label.fields__label.fields__label--small
                    | {{ $i18n.t('battle.battle_label_period_modal') }}
                cs-datepicker.fields__input.datepicker-input-container--no-margin(
                    :language="authUser.locale",
                    :disabled-dates="dateTo ? {from: new Date(dateTo)} : {}",
                    v-validate='`required|date_format:YYYY-MM-DD`',
                    @input="dateFrom = dateToMoment($event, 'YYYY-MM-DD hh:mm:ss')",
                    :value="dateFrom",
                    name="dateFrom"
                )
                .fields__divider —
                cs-datepicker.fields__input.datepicker-input-container--no-margin(
                    :language="authUser.locale",
                    :disabled-dates="dateFrom ? {to: new Date(dateFrom)} : {}",
                    v-validate='`required|date_format:YYYY-MM-DD`',
                    @input="dateTo = dateToMoment($event, 'YYYY-MM-DD hh:mm:ss')",
                    :value="dateTo",
                    name="dateTo"
                )
            .create-body__buttons
                cs-button(
                    color="blue"
                    @click="getRecordHolderBattles"
                    :disabled="isDisableButton"
                )
                  | {{ $i18n.t('battle.battle_get_user_record_holder_text_button') }}
            template(v-if="recordHolders == null")
                p.list-record-holders
                   | {{ $i18n.t('battle.batlle_record_holder_select_time_interval') }}
            template(v-else-if="recordHolders.length > 0")
                p.list-record-holders(v-for="user in recordHolders")
                    a.list-record-holders-href(:href="getLinkUser(user.userId)" target="_blank")
                        | {{ user.user.fullName }} - {{ participantsCountText(user.count) }}
            template(v-else="recordHolders")
                p.list-record-holders
                    | {{ $i18n.t('errors.not_find_record_holder_battles') }}
</template>

<script>
/*eslint-disable*/
import BattleApi from '../api/battle';
import CsModal from '../elements/CsModal.vue'
import {mapState} from 'vuex';
import moment from "moment";

export default {
    components: {
        CsModal,
    },
    data () {
        return {
            dateFrom: null,
            dateTo: null,
            recordHolders: null,
        }
    },
    methods: {
        getLinkUser (id) {
            return "/user/student/"+id;
        },
        participantsCountText (count) {
            return count + ' '
                + this.$i18n.tc('battle.battle_showPage_participantDeclination', count);
        },
        getRecordHolderBattles() {
            let form = {
                dateFrom: this.dateFrom,
                dateTo: this.dateTo
            };
            BattleApi.getRecordHolderBattles(form).then((data) => {
                this.recordHolders = data.recordHolderBattles;
            }).catch(err => {
                this.recordHolders = [];
            });
        },
        closeCreateMessageModal() {
            this.$emit('close');
        },
        dateToMoment (date, format) {
            this.$nextTick(() => {
                this.$validator.validate('dateTo');
                this.$validator.validate('dateFrom');
            })
            return moment(date).format(format);
        },
    },
    computed: {
        ...mapState({
            authUser: state => state.auth.user
        }),
        isDisableButton () {
            return !(this.dateTo && this.dateFrom);
        }
    }
}
</script>

<style lang="scss" scoped>
    .create-body {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        box-sizing: border-box;
        width: 100%;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
        @include media($xlg) {
            width: 80%;
        }
    }
    .create-modal__header {
        font-size: 22px;
        font-weight: 500;
        margin-top: 15px;
        min-height: 400px;
    }

    .create-body__buttons {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .fields__input {
        min-width: 0;
        flex: 1 1 auto;
        margin-bottom: 0;
    }

    .fields__divider {
        text-align: center;
        @include media($md) {
            margin: 0 $space-x-small;
        }
    }

    .fields__label {
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        min-width: 6.5em;
        @include media($md) {
            text-align: right;
        }
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .fields__label--small {
        @include media($xlg) {
            min-width: 5em;
        }
    }
    .list-record-holders {
        font-size: 20px;
        line-height: 24px;
        color: #333333;
    }
    .list-record-holders-href {
        color: #1f87ff;
        cursor: pointer;
    }
</style>
